<template>
    <section class="about-cegjelzo" id="rolunk">
        <div class="container">
          <div class="row">
            <div class="col-md-4 text-center d-block d-md-none">
              <img src="@/assets/img/screenshot-white.png" />
            </div>
            <div class="col-md-8">
              <div class="row list-row">
                <i class="far fa-check-square col-md-1"></i>
                <span class="col-md-10">Gyors ellenőrzés tárgyalás előtt</span>
              </div>

              <div class="row list-row">
                <i class="far fa-check-square col-md-1"></i>
                <span class="col-md-10">Konferencián névjegykártya alapján</span>
              </div>

              <div class="row list-row">
                <i class="far fa-check-square col-md-1"></i>
                <span class="col-md-10">Leendő ügyfelek validálása azonnal, kényelmesen</span>
              </div>

              <div class="row list-row">
                <i class="far fa-check-square col-md-1"></i>
                <span class="col-md-10">Releváns partnerinformáció másodpercek alatt</span>
              </div>

              <div class="row list-row">
                <i class="far fa-check-square col-md-1"></i>
                <span class="col-md-10">Cégek, egyéni vállalkozások és civilszervezetek adatbázisa</span>
              </div>
            </div>
            <div class="col-md-4 text-center d-md-block d-none">
              <img src="@/assets/img/screenshot-white.png" />
            </div>
          </div>
          <div class="row text-center justify-content-center cta-row">
            <a href="http://m.me/cegjelzo?ref=propromo" class="btn btn-orange col-md-6 col-xs-12" target="_blank">KÉREK MESSENGER ÜZENETET</a>
          </div>
          <div class="row text-center">
            <p>Ha szeretnél értesülni a Messenger Céginfó megjelenéséről, akkor a felugró ablakban engedélyezd a Messengereddel való kommunikációt.</p>
          </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "AboutCegjelzo",
  data() {
    return {
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.about-cegjelzo {
  background: white;
}

img {
  max-width: 100%;
}

.fa-check-square {
  color: var(--color-green-1);
  font-size: 2em;
  margin-right: 24px;
  margin-top: auto;
  margin-bottom: auto;
}

.list-row {
  margin-top: 42px;
  margin-bottom: 42px;
}

h1 {
  text-align: left;
  margin-bottom: 48px;
}

span {
  font-size: 28px;
}

.cta-row { 
  margin-top: 48px;
  margin-bottom: 48px;
}

@media (max-width: 768px) {
  .list-row {
    text-align: center;
  }
}
</style>
